<template>
  <div class="dateSingleOrRange">
    <RadioTop :options="['今日', '明日', '全部', '自訂']" :defaultValue="type" @input="typeChange($event)" @same="same"/>
    <div class="pop" v-show="show">
      <DateInput :style="{height: '40px', width: '400px'}"  v-if="show"
      :defaultValue="range" @input="range=$event"/>
      <button class="closeBtn" @click="show=false"></button>
    </div>
  </div>
</template>

<script>
import DateInput from '../input/dateRange.vue'
import RadioTop from '../radio/r1.vue'
export default {
  props: ['defaultValue'],
  name: 'dateSingleOrRange',
  components: {
    RadioTop,
    DateInput
  },
  data () {
    return {
      type: '今日',
      show: false,
      range: {
        start: this.moment().format('yyyy-MM-DD'),
        duration: 0,
        end: this.moment().format('yyyy-MM-DD')
      }
    }
  },
  watch: {
    defaultValue: {
      handler () {
        const today = this.moment().format('yyyy-MM-DD')
        const tomorrow = this.moment().add(1, 'day').format('yyyy-MM-DD')
        console.log('defaultValue defaultValue defaultValue', this.defaultValue.start === today, this.defaultValue.start === tomorrow, this.defaultValue.duration === 1)
        if (this.defaultValue.start === this.range.start && this.defaultValue.end === this.range.end) {
        } else if (this.defaultValue.start === today && this.defaultValue.duration === 0) {
          this.type = '今日'
          this.range = {
            start: today,
            end: today,
            duration: 0
          }
        } else if (this.defaultValue.start === tomorrow && this.defaultValue.duration === 0) {
          this.type = '明日'
          this.range = {
            start: tomorrow,
            end: tomorrow,
            duration: 0
          }
        } else if (this.defaultValue.start === today && this.defaultValue.duration === null) {
          this.type = '全部'
          this.range = {
            start: tomorrow,
            end: null,
            duration: null
          }
        } else {
          this.type = '自訂'
          this.range = {
            start: this.defaultValue.start,
            end: this.defaultValue.end,
            duration: this.defaultValue.duration
          }
        }
        console.log(this.type)
      },
      immediate: true,
      deep: true
    },
    range: {
      handler () {
        if (this.defaultValue.start === this.range.start && this.defaultValue.end === this.range.end) {
        } else if (this.range.start && this.range.end) {
          this.range.duration = this.moment(this.range.end).diff(this.moment(this.range.start), 'day')
          if (this.type === '自訂') {
            this.$emit('input', this.range)
            this.show = false
          }
        }
      },
      deep: true
    }
  },
  methods: {
    typeChange (ev) {
      console.log('typeChange', ev)
      const today = this.moment().format('yyyy-MM-DD')
      const tomorrow = this.moment().add(1, 'day').format('yyyy-MM-DD')
      if (ev === '今日') {
        this.type = '今日'
        this.range.start = today
        this.range.duration = 0
        this.range.end = today
        this.show = false
        this.$emit('input', this.range)
      } else if (ev === '明日') {
        this.type = '明日'
        this.range.start = tomorrow
        this.range.duration = 0
        this.range.end = tomorrow
        this.show = false
        this.$emit('input', this.range)
      } else if (ev === '全部') {
        this.type = '全部'
        this.range.start = today
        this.range.duration = null
        this.range.end = null
        this.show = false
        this.$emit('input', this.range)
      } else if (ev === '自訂') {
        this.type = '自訂'
        this.show = true
      }
    },
    same (ev) {
      console.log('same', ev)
      if (ev === '自訂') {
        this.show = !this.show
      }
    }
  }
}
</script>
<style lang="scss">
.dateSingleOrRange {
#setDate-wrapper #setDate-input {
  border-color: #C4C4C4;
}
  #setDateRange-wrapper #setDateRange-input {
    height: 40px;
    letter-spacing: 0;
  }
}
</style>
<style lang="scss" scoped>
.closeBtn {
  margin-left: 6px;
  width: 36px;
  height: 36px;
  border: none;
  background-color: var(--color-pri);
  mask-image: url(/close.svg);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
.dateSingleOrRange {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 14px;
  position: relative;
}
.pop {
  position: absolute;
  top: 42px;
  height: 60px;
  right: 0;
  padding: 10px;
  background: #FFFFFF;
  box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.25), -2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  display: flex;
  align-items: center;
  z-index: 100;
}
</style>
